import { PlusIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@/components/ui/empty';

interface EmptyContactsProps {
  canWrite: boolean;
  onCreate: () => void;
}

export const EmptyContacts = ({ canWrite, onCreate }: EmptyContactsProps) => {
  const { t } = useTranslation();

  return (
    <Empty>
      <EmptyHeader>
        <EmptyMedia>
          <img src="/assets/empty-states/contacts.webp" alt="" />
        </EmptyMedia>
        <EmptyTitle>{t('contacts.empty_title')}</EmptyTitle>
        <EmptyDescription>{t('contacts.empty_description')}</EmptyDescription>
      </EmptyHeader>
      {canWrite && (
        <EmptyContent>
          <Button size="sm" onClick={onCreate}>
            <PlusIcon size={16} />
            {t('contacts.add')}
          </Button>
        </EmptyContent>
      )}
    </Empty>
  );
};
